<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          {{ $t('tsProxyList') }}
          <v-spacer></v-spacer>
          <v-text-field id="bad952ff" v-model="search" :label="$t('search')" append-icon="mdi-magnify" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          id="392966cd"
          must-sort
          :search="search"
          :headers="headers"
          :items="tsProxyList"
          :options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :loading-text="$t('dataTable.loadingPleaseWait')"
          :no-data-text="$t('dataTable.noDataAvailable')"
          :no-results-text="$t('dataTable.noMatchingRecordsFound')"
          :footer-props="{
            'items-per-page-text': $t('dataFooter.itemsPerPage'),
            'page-text': $t('dataFooter.pageText'),
            'items-per-page-options': [10,25,50]
          }"
        >
          <template v-if="isAdmin" v-slot:item.action="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('8542953c', item.name)" icon :to="'tsProxies/' + item.name + '/update'" v-on="on">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('update') }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn :id="setTableItemOperationDynamicId('304ccc44', item.name)" icon v-on="on" @click="deleteTsProxy(item.name)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <fab-button v-if="isAdmin" id="ea2f51a1" tooltip-text="add" to="tsProxies/add" />
    </v-flex>
  </v-layout>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
import Role from '../../Role'
import signers from '../../api/signers'
import FabButton from '../../components/FabButton.vue'
import { showToastSuccess, showToastError, showConfirmationDialog } from '../../event-bus'

export default {
  name: 'TsProxyList',

  components: {
    'fab-button': FabButton
  },

  data() {
    return {
      search: null,
      pagination: {
        sortBy: ['name']
      },
      tsProxyList: [],
      totalItems: 0,
      loading: false,
      headers: [
        {
          text: this.$t('name'),
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t('failureThreshold'),
          value: 'failureTreshold',
          sortable: false
        },
        {
          text: this.$t('retryTimeout'),
          value: 'retryTimeout',
          sortable: false
        },
        {
          text: this.$t('actions'),
          value: 'action',
          sortable: false
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    }
  },

  watch: {
    search() {
      this.loading = true
      this.searchTsProxyWatcher()
    },

    pagination() {
      this.searchTsProxies()
    }
  },

  methods: {
    async searchTsProxies() {
      this.loading = true
      try {
        let pageRequest = {
          'page-num': this.pagination.page,
          'page-size': this.pagination.itemsPerPage,
          'sort-field': this.pagination.sortBy[0],
          'sort-order': this.pagination.sortDesc[0] ? 'desc' : 'asc'
        }
        let page = await signers.listTsProxies(this.search, pageRequest)
        this.tsProxyList = page.content
        this.totalItems = page.total
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.loading = false
      }
    },

    searchTsProxyWatcher: debounce(function() {
      this.searchTsProxies()
    }, 500),

    async deleteTsProxy(name) {
      let conf = await showConfirmationDialog(this.$t('confirmation'), this.$t('dialog.text.deleteItem'), false, null)
      if (!conf.confirmedValue) {
        return
      }

      try {
        await signers.deleteTsProxy(name, conf.confirmedCheckboxValue)
        this.searchTsProxies()
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if (error.response != null) {
          switch (error.response.data.code) {
            case 'STILL_REFERENCED':
              errorMsg = this.$t('toastMessage.stillReferenced', { param: 'TsProxy', param2: 'keyAlias' })
              break
            case 'GENERAL':
              errorMsg = '(' + error.response.data.code + ')' + ' ' + error.response.data.message
          }
        }
        showToastError(errorMsg)
      }
    }
  }
}
</script>
